import React, { useState } from 'react';
import { environment } from '../../environment';

const BookImage = ({className="", path, name="desconhecido", author="desconhecido"}) => {
  const [error, setError] = useState(false);

  const onErrorImage = () => {
    setError(true);
  };

  if(!path || error) return (
    <img 
      className={className}
      src={environment.noCoverBook}
      onError={onErrorImage}
      draggable="false"
      alt={`Imagem do livro não encontrada | Escrito por ${author}`}/>
  )

  return <img 
          className={className}
          src={path}
          onError={onErrorImage}
          draggable="false"
          alt={`Imagem do livro ${name} | Escrito por ${author}`}/>
}

export default BookImage;